/*
 * � 2020 Microsoft. All rights reserved.
 */

define('MenuUI/MenuTab',['pixi', 'absolute', 'lodash', 'MenuUI/Label', 'MenuUI/DropShadow', 'Managers/ScaleManager'],

	function (PIXI, Absolute, _, Label, DropShadow, ScaleManager) {

		var MenuTab = function (config) {

			var defaultConfig = {
				color: 0x862627,
				borderColor: 0xbe7272,
				tabWidth: Absolute.Coords.x(575),
				tabPosition: Absolute.Coords.x(36),
				selected: false,
				letterStyle: {
					font: 'bold ' + Absolute.ScreenMetrics.getResScale() * 40 + 'px Arial',
					fontFamily: 'segoe',
					fill: '#ffffff',
					tint: 0xffffff,
					align: 'left'
				},
				width: Absolute.Coords.x(1821),
				height: Absolute.Coords.y(551),
				selectedCallback: ''
			};
			this.initMenuTab(_.extend(defaultConfig, config));
		};

		MenuTab.prototype = Object.create(PIXI.DisplayObjectContainer.prototype);

		MenuTab.prototype.initMenuTab = function (config) {

			PIXI.DisplayObjectContainer.call(this);

			this.config = config;

			if (this.config.disabled) {
				this.config.letterStyle.tint = 0xa3a3a3;
			}

			this.lineWeight = Absolute.Coords.x(3);
			this.tabHeightSelected = this.config.tabHeightSelected;
			this.tabHeight = this.config.tabHeight;
			this.coverBaseStrokeOffset = Absolute.Coords.y(10);

			this.drawBaseRect();

			this.tabSelected = new PIXI.Graphics();
			this.tab = new PIXI.Graphics();
			this.tabStrokeSelected = new PIXI.Graphics();
			this.tabStroke = new PIXI.Graphics();


			this.dropShadow = new DropShadow({
				beginningShade: 0.03,
				baseWidth: this.baseRect.width,
				baseHeight: this.baseRect.height
			});
			this.dropShadow.y = this.tabHeightSelected;
			this.addChildAt(this.dropShadow, 0);

			this.contentContainer = new PIXI.DisplayObjectContainer();

			this.setContent(this.config.content);

			this.tabSelected.beginFill(this.config.color);
			this.tabSelected.drawRect(this.config.tabPosition, 0, this.config.tabWidth, this.tabHeightSelected + this.coverBaseStrokeOffset);
			this.tabSelected.endFill();

			this.tab.beginFill(this.config.color);
			this.tab.drawRect(this.config.tabPosition, this.tabHeightSelected - this.tabHeight, this.config.tabWidth, this.tabHeight + this.coverBaseStrokeOffset);
			this.tab.endFill();
			this.tab.interactive = true;
			this.tab.buttonMode = !this.config.disabled;

			this.addChild(this.tabSelected);
			this.addChild(this.tab);

			if (Absolute.Platform.supportsTouch()) {
				this.tab.touchstart = this.tabSelectedAction.bind(this);
				if (Absolute.Platform._isWindows() || (Absolute.Platform._isMac() && !Absolute.Platform._isIOS())) {
					this.tab.mousedown = this.tabSelectedAction.bind(this);
				}
			} else {
				this.tab.mousedown = this.tabSelectedAction.bind(this);
				this.tab.mouseover = this.handleMouseOverAction.bind(this);
				this.tab.mouseout = this.handleMouseOutAction.bind(this);
				this.tabSelected.mouseover = this.handleMouseOverAction.bind(this);
				this.tabSelected.mouseout = this.handleMouseOutAction.bind(this);
			}


			this.initTabStrokeSelected(this.config.borderColor);
			this.initTabStroke(this.config.borderColor);

			this.label = new Label({
				text: this.config.label,
				icon: this.config.labelIcon,
				iconScale: this.config.labelIconScale,
				letterStyle: this.config.letterStyle
			});
			this.label.x = this.config.tabPosition + Absolute.Coords.x(15);

			if (this.config.disabled) {
				this.label.icon.alpha = 0.5;
			}

			// this.addChild(this.tabStrokeSelected);
			// this.addChild(this.tabStroke);
			this.addChild(this.contentContainer);

			this.focusIndicator = new PIXI.Graphics();
			this.focusIndicator.lineStyle(Absolute.Coords.x(3), 0xFFFFFF);
			this.addChild(this.focusIndicator);
			this.focusIndicator.visible = false;

			this.updateState(this.config.selected);
			this.baseRect.visible = this.config.selected;
			this.dropShadow.visible = this.config.selected;
			this.content.visible = this.config.selected;

		};

		MenuTab.prototype.drawBaseRect = function () {
			if (this.children.indexOf(this.baseRect) !== -1) {
				this.removeChild(this.baseRect);
			}
			this.baseRect = new PIXI.Graphics();
			this.baseRect.beginFill(this.config.color);
			this.baseRect.lineStyle(this.lineWeight, this.config.borderColor);
			this.baseRect.drawRect(0, this.tabHeightSelected,
				this.config.width,
				this.config.height);
			this.baseRect.endFill();
			this.addChildAt(this.baseRect, 0);
		};

		MenuTab.prototype.setSelected = function () {
			this.tabSelectedAction();
		};

		MenuTab.prototype.tabSelectedAction = function () {


			if (this.config.disabled) {
				return;
			}

			if (typeof this.config.selectedCallback === 'function') {
				this.config.selectedCallback(this);
			}
			this.updateState(true);
		};

		MenuTab.prototype.updateState = function (selected) {
			this.tabStrokeSelected.visible = this.tabSelected.visible = selected;
			this.tabStroke.visible = this.tab.visible = !selected;
			this.selected = selected;
			if (selected) {
				this.label.y = Absolute.Coords.y(20 * this.config.labelIconScale); // Maby change name to just scale instead of labeliconscale
				this.tabSelected.addChild(this.label);
				this.drawFocusRect(0, this.tabSelected.width, this.tabSelected.height - 10);
			} else {
				this.label.y = Absolute.Coords.y(30 * this.config.labelIconScale);
				this.tab.addChild(this.label);
				this.drawFocusRect(20, this.tab.width, this.tab.height);
			}
		};

		MenuTab.prototype.drawFocusRect = function (y, w, h) {
			this.focusIndicator.clear();
			this.focusIndicator.lineStyle(Absolute.Coords.x(3), 0xFFFFFF);
			this.focusIndicator.drawRect(this.label.x - 15, y, w, h);
		};

		MenuTab.prototype.setContent = function (content) {
			while (this.contentContainer.children.length > 0) {
				this.contentContainer.removeChildAt(0);
			}
			if (content) {
				this.contentContainer.addChild(content);
			}
			this.content = content;
		};

		MenuTab.prototype.setLabel = function (text) {
			if (this.tabSelected.visible) {
				this.tabSelected.removeChild(this.label);
			} else {
				this.tab.removeChild(this.label);
			}
			this.label = new Label({
				text: text,
				icon: this.config.labelIcon,
				iconScale: this.config.labelIconScale,
				letterStyle: this.config.letterStyle
			});
			this.label.x = this.config.tabPosition + Absolute.Coords.x(15);

			this.updateState(true);
		};

		MenuTab.prototype.onHide = function () {
			this.baseRect.visible = false;
			this.dropShadow.visible = false;
			this.content.visible = false;
			this.content.onHide();
		};

		MenuTab.prototype.onShow = function () {
			this.baseRect.visible = true;
			this.dropShadow.visible = true;
			this.content.visible = true;
			this.content.onShow();
		};

		MenuTab.prototype._focusChanged = function () {
			this.focusIndicator.visible = !!this.tab._hasFocus;
		};

		MenuTab.prototype.handleActivate = function () {
			this.tabSelectedAction();
		};

		Object.defineProperty(MenuTab.prototype, "focus", {
			get: function () {
				return this.tab._hasFocus;
			},
			set: function (value) {
				this.tab._hasFocus = value;
				this._focusChanged();
				return value;
			}
		});

		MenuTab.prototype.handleMouseOverAction = function () {
			this.updateTabState();
			this.label.labelText.style.fill = '#ffffff';
			this.updateTabState();
			this.label.labelText.updateText();
		};

		MenuTab.prototype.handleMouseOutAction = function () {
			this.updateTabState(true);
			this.label.labelText.style.fill = this.config.letterStyle.fill;
			this.label.labelText.updateText();
		};

		MenuTab.prototype.updateTabState = function (isMouseOut) {
			if (this.tabStrokeSelected) {
				this.removeChild(this.tabStrokeSelected);
			}
			if (this.tabStroke) {
				this.removeChild(this.tabStroke);
			}
			this.initTabStrokeSelected(isMouseOut ? this.config.borderColor :
				(this.config.hoverBorderColor ? this.config.hoverBorderColor : this.config.borderColor));
			this.initTabStroke(isMouseOut ? this.config.borderColor :
				(this.config.hoverBorderColor ? this.config.hoverBorderColor : this.config.borderColor));
		};

		MenuTab.prototype.initTabStrokeSelected = function (color) {
			this.tabStrokeSelected.moveTo(this.config.tabPosition, this.tabHeightSelected);
			this.tabStrokeSelected.lineStyle(this.lineWeight, color);
			this.tabStrokeSelected.lineTo(this.config.tabPosition, 0);
			this.tabStrokeSelected.lineTo(this.config.tabPosition + this.config.tabWidth, 0);
			this.tabStrokeSelected.lineTo(this.config.tabPosition + this.config.tabWidth, this.tabHeightSelected);
			this.addChild(this.tabStrokeSelected);
		};

		MenuTab.prototype.initTabStroke = function (color) {
			this.tabStroke.moveTo(this.config.tabPosition, this.tabHeightSelected);
			this.tabStroke.lineStyle(this.lineWeight, color);
			this.tabStroke.lineTo(this.config.tabPosition, this.tabHeightSelected - this.tabHeight);
			this.tabStroke.lineTo(this.config.tabPosition + this.config.tabWidth, this.tabHeightSelected - this.tabHeight);
			this.tabStroke.lineTo(this.config.tabPosition + this.config.tabWidth, this.tabHeightSelected);
			this.addChild(this.tabStroke);
		};

		return MenuTab;

	});

